module.exports = __webpack_public_path__ + "assets/df3a05187683e39558cae33b0cfedbb7.png";